const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_f_344_14120)">
      <circle cx="52" cy="52" r="21" fill="white" fillOpacity="0.5" />
    </g>
    <path
      d="M52 72C63.0457 72 72 63.0457 72 52C72 40.9543 63.0457 32 52 32C40.9543 32 32 40.9543 32 52C32 63.0457 40.9543 72 52 72Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47 45.9307C47 44.9761 47 44.4988 47.1995 44.2324C47.3733 44.0001 47.6394 43.8549 47.9288 43.8342C48.2608 43.8105 48.6622 44.0686 49.4652 44.5848L58.9064 50.6541C59.6032 51.102 59.9516 51.326 60.0719 51.6108C60.177 51.8596 60.177 52.1404 60.0719 52.3892C59.9516 52.674 59.6032 52.898 58.9064 53.3459L49.4652 59.4152C48.6622 59.9314 48.2608 60.1895 47.9288 60.1658C47.6394 60.1451 47.3733 59.9998 47.1995 59.7676C47 59.5012 47 59.0239 47 58.0693V45.9307Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_f_344_14120"
        x="0"
        y="0"
        width="104"
        height="104"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="15.5"
          result="effect1_foregroundBlur_344_14120"
        />
      </filter>
    </defs>
  </svg>
);

export default PlayIcon;
